import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss', './header.component.en.scss']
})
export class HeaderComponent implements OnInit{
  constructor(@Inject(DOCUMENT) private document: Document, private dataService: DataService) { }
  @Output() openSidebar: EventEmitter<void> = new EventEmitter<void>();
  @Input() generalSettingsData:any;
  portalTypeTitle?: string;
  portalTypeIconUrl?: string;
  showStream: boolean = true;
  ngOnInit() {
    this.dataService.updateGeneralSettingsData$.subscribe((value: any) => {
      setTimeout(() => {
        if(!this.generalSettingsData) return;
        if(this.generalSettingsData.userDetails.sessionSiteViewType === 1){
          this.portalTypeTitle = this.generalSettingsData.portalGeneralSettingsData.studentPortalSiteTitle;
          this.portalTypeIconUrl = this.generalSettingsData.portalGeneralSettingsData.portalStudentTypeIconUrl;
        }
        else if(this.generalSettingsData.userDetails.sessionSiteViewType === 2) {
          this.portalTypeTitle = this.generalSettingsData.portalGeneralSettingsData.staffPortalSiteTitle;
          this.portalTypeIconUrl = this.generalSettingsData.portalGeneralSettingsData.portalStaffTypeIconUrl;
        }
      }, 100);
    })
  }
  toggleSidebar() {
    this.openSidebar.emit();
  }
}
